import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=1fc9e825&scoped=true&"
import script from "./OrderAddress.vue?vue&type=script&lang=js&"
export * from "./OrderAddress.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddress.vue?vue&type=style&index=0&id=1fc9e825&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc9e825",
  null
  
)

export default component.exports